module.exports = __webpack_public_path__ + "static/media/transfer-funds-card.0cc8ed24.png";